/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useState} from "react";
import {Grid, Box, CssBaseline, Paper} from "@mui/material";
import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import {CompTextField} from "../../../components/TextField";
import { ButtonPrimary } from "../../../components/newComponents/ButtonPrimary.js";
import { CompRadioGroup } from "../../../components/RadioGroup.js";
import {apiAction} from "../../api/actions";
import settings from "../../api/settings";
import i18n from "../../../i18n.js";
import AppHeader from "../../../components/newComponents/AppHeader.js";
import QRCode from 'qrcode';
import Typography from "@mui/material/Typography";
import { ButtonSecondary } from "../../../components/newComponents/ButtonSecondary.js";
import {ageOptions, genderOptions, ageOptionsNew} from "./feedbackOptionsNew";
import { useParams } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";
import { useNavigate } from 'react-router-dom';

const searchFunction = (queryString, onSuccess, onFailure) => {
    return apiAction({
        url: `${settings.baseURL}/feedback/${queryString}`,
        onSuccess: onSuccess,
        onFailure: onFailure,
        label: "something"
    });
}

const sendFeedbackItem = (queryString, data, onSuccess, onFailure) => {
    return apiAction({
        url: `${settings.baseURL}/feedback/add/${queryString}`,
        data: data,
        method: "POST",
        onSuccess: onSuccess,
        onFailure: onFailure,
        label: "something"
    });
}

const FeedbackComponent = ({searchFunction,sendFeedbackItem, ...props}) => {

    const { code } = useParams();

    let initialCode = '';
    let language = null;
    let mode = 0;
    let searchMode = false;
    let preview = false;

    if (code) {
        const array = code.split("-");

        for (var i = 0; i < array.length; i++) {
            var v = array[i];
            if (v === "0") {mode = 0}
            else if (v === "1") {mode = 1}
            else if (v === "2") {mode = 2}
            else if (v === "3") {mode = 3}
            else if (v === "4") {mode = 4}
            else if (v === "fi") {language = "fi"}
            else if (v === "sv") {language = "sv"}
            else if (v === "preview") {preview = true}
            else {
                initialCode = v;
            }
        }
        searchMode = true;
    }
    const [qr, setQr] = useState(null);
    if (window.location.href.includes("-preview") && qr === null) {
        QRCode.toDataURL(window.location.href.replace("-preview", ""), {
            width: 400,
            margin: 2,
        }, (err, url) => {
            if (err) return console.error(err);
            setQr(url);
            })
    }


    const {t} = useTranslation('translation');
    document.title = t('common.feedback') + " - " + t('common.title');

    if (language && i18n.language !== language) {
        i18n.changeLanguage(language);
    }

    const [firstCode, setFirstCode] = useState(initialCode);
    const [clicked, setClicked] = useState(false);
    const [age, setAge] = useState(null);
    const [gender, setGender] = useState(null);
    const [rating, setRating] = useState(null);
    const [comment, setComment] = useState('');
    const [currentMode, setCurrentMode] = useState(mode);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState(searchMode);
    const [useAgeAndGender, setUseAgeAndGender] = useState(false);
    const [useFeedbackRating, setUseFeedbackRating] = useState(false);
    const [useFeedbackComment, setUseFeedbackComment] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [sent, setSent] = useState(false);
    const [name, setName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [newAgeOption, setNewAgeOption] = useState(false);
    const [feedbackCode, setFeedbackCode] = useState(null);
    const [feedbackList, setFeedbackList] = useState([]);
    const [locationFeedbackCode, setLocationFeedbackCode] = useState(null);
    const [locationName, setLocationName] = useState(null);
    
    const navigate = useNavigate();
    
    const logoLang = i18n.language === 'fi' ? 'Logo_nuodo_login_new2025' : 'Logo_ungdo_login_new2025';
    const logoSrc = `${process.env.PUBLIC_URL}/media/images/${logoLang}.svg`;
        //0 none found, 1 found not yet chosen, 2 feedback, 3 signUp
    useEffect(() => {
        if (clicked) {
            setClicked(false);
            //search();
            setCurrentMode(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clicked]);

    useEffect(() => {
        if (search) {
            setSearch(false);
            handleSearch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const handleChange = (e) => {
        setFirstCode(e.target.value);
    };

    const sendFeedback = () => {
        const data = {};
        data.age = currentMode === 3 ? age : null;
        data.gender = currentMode === 3 ? gender : null;
        data.rating = currentMode === 2 && useFeedbackRating ? rating : null;
        data.comment = currentMode === 2 && useFeedbackComment ? comment : null;

        sendFeedbackItem(feedbackCode, data, () => {
            setSent(true);
            setError(null);
            goBack();
            return {type: "ignore", payload: "ignore"};
        },
        (error) => {
            let data = "Connection error";
            if (error.response && error.response.data && error.response.data.data) data = error.response.data.data.error;
            setError(data);
            return {type: "ignore", payload: "ignore"};
        });
    };

    const goBack = () => {
        setDisabled(false);
        setAge(null);
        setGender(null);
        setRating(null);
        setComment('');
        setCurrentMode(1);
        setError(null);
    };

    const handleGoBack = () => {
        navigate('/login');
    };

    const handleBackToFeedbackList = () => {
        setCurrentMode(5);

        searchFunction(locationFeedbackCode, (data, response) => {
            if (data.length === 1 && !data[0].id) {
                setFeedbackList([]);
            }
            else {
                setFeedbackList(data);
            }
            setLocationName(data[0].locationName)
            setError(null);
            
            return {type: "ignore", payload: "ignore"};
        },
        (data) => {
            setError(t('feedback.'+data.response.data.data.error));
            return {type: "ignore", payload: "ignore"};
        })
    }

    const ratingOptions = [
        {
            label: "😁 "+t('feedback.excellent'),
            value: "5"
        },
        {
            label: "🙂"+t('feedback.nice'),
            value: "4"
        },
        {
            label: "😐 "+t('feedback.neutral'),
            value: "3"
        },
        {
            label: "🙁"+t('feedback.bad'),
            value: "2"
        },
        {
            label: "😠 "+t('feedback.verybad'),
            value: "1"
        },
        {
            label: t('feedback.not_answered'),
            value: "-1"
        },
    ]

    let ageComp = (
        <Grid
            size={{
                xs: 12,
                sm: 6
            }}>
            <div className={'label label-size'}>{t('feedback.ageOptions')}</div>
            
            <CompRadioGroup
                large={false}
                name="ageOptions"
                selected={age}
                rows={newAgeOption ? ageOptionsNew : ageOptions}
                labelTranslation={true}
                disabled={disabled}
                onChange={(e) => setAge(e.target.value)}
            />
        </Grid>
    )

    let genderComp = (
        <Grid
            size={{
                xs: 12,
                sm: 6
            }}>
            <div className={'label label-size'}>{t('feedback.genderOptions')}</div>

            <CompRadioGroup
                large={false}
                name="genderOptions"
                selected={gender}
                disabled={disabled}
                rows={genderOptions}
                labelTranslation={true}
                onChange={(e) => setGender(e.target.value)}
            />
        </Grid>
    )
    
    let feedbackRating = (
        <Grid
            size={{
                xs: 12,
                sm: 12
            }}>
            <Typography variant='h6'>{t('feedback.rating')} *</Typography>

            <CompRadioGroup
                large={false}
                name="ratingOptions"
                selected={rating}
                rows={ratingOptions}
                disabled={disabled}
                onChange={(e) => setRating(e.target.value)}
            />
        </Grid>
    )

    let feedbackComment = (
        <>
            <div className={'label label-size'}>{t('feedback.free_form_feedback')}</div>
            <Grid
                size={{
                    xs: 12,
                    sm: 12
                }}>
                <CompTextField
                    value={comment}
                    name="comment"
                    multiline
                    fullWidth
                    disabled={disabled}
                    rows={6}
                    inputProps={{maxLength: 2000}}
                    onChange={(e) => setComment(e.target.value)}
                />
            </Grid>
        </>
    )

    const handleSearch = () => {
        searchFunction(firstCode, (data, response) => {
            if (data.length >= 0) {
                setLocationName(data[0].locationName);
            }

            if (data.length === 1 && !data[0].id) {
                setFeedbackList([]);
                setCurrentMode(5);
            }
            else if (data.length === 1 ) {
                selectFeedback(data[0])
            }
            else {
                if (currentMode === 0) {
                    setCurrentMode(5);
                    setFeedbackList(data);
                    setError(null);
                }
            }
            return {type: "ignore", payload: "ignore"};
        },
        (data) => {
            setError(t('feedback.'+data.response.data.data.error));
            return {type: "ignore", payload: "ignore"};
        })
    };

    const selectFeedback = (feedback) => {
        setName(feedback.name);
        setLocationFeedbackCode(feedback.locationFeedbackCode);
        setStartDate(feedback.functionStartDatetime);
        setEndDate(feedback.functionEndDatetime);
        setUseAgeAndGender(feedback.ageAndGender === true);
        setUseFeedbackComment(feedback.feedbackComment === true);
        setUseFeedbackRating(feedback.feedbackRating === true);
        setNewAgeOption(feedback.useNewAge === true);
        setFeedbackCode(feedback.code);
        setError(null);
        if (currentMode === 0 || currentMode === 5) {
            setCurrentMode(1);
        }
    }

    const getDate = () => {
        if (startDate && endDate) {
            var dateStartArray = (startDate.split("T")[0]).split("-");
            var dateStart = dateStartArray[2]+"."+dateStartArray[1]+"."+dateStartArray[0];

            var dateEndArray = (endDate.split("T")[0]).split("-");
            var dateEnd = dateEndArray[2]+"."+dateEndArray[1]+"."+dateEndArray[0];
            if (dateStart === dateEnd) {
                return dateStart;
            }
            else {
                return dateStart + " - " + dateEnd;
            }
        }
        else {
            return "";
        }
    }

    const dateOptions = {
        hour: 'numeric',
        minute: '2-digit'
    };

    const chooseFeedbackF = () => {
        setSent(false);
        setCurrentMode(2);
    };
    const chooseSignUpF = () => {
        setSent(false);
        setCurrentMode(3);
    };

    let chooseFeedback = (
        <ButtonPrimary item sm={6} style={{width: "100%"}} className="buttonText" onClick={() => chooseFeedbackF()}>
            {t('feedback.sendFeedback')}
        </ButtonPrimary>
    )
    let chooseSignUp = (
        <ButtonPrimary item sm={6} style={{width: "100%"}} className="buttonText" onClick={() => chooseSignUpF()}>
            {t('feedback.sendSignUp')}
        </ButtonPrimary>
    )

    let sendFeedbackButton = (
        <ButtonPrimary
            disabled={
                (currentMode === 3 && (disabled || gender === null || age === null)) ||
                (currentMode === 2 && (disabled || rating === null))
            }
            className="buttonText"
            onClick={() => sendFeedback()}
            style={{width: "30%"}}
        >
            {t('feedback.send')}
        </ButtonPrimary>
    )

    let backButton = (
        <ButtonSecondary style={{width: "30%"}} className="buttonText" onClick={() => goBack()}>
            {t('feedback.goBack')}
        </ButtonSecondary>
    );
 
    let searchView = (
        <Grid
            className={'search-input'}
            size={{
                xs: 12,
                sm: 8
            }}>
            <CompTextField
                label={t('feedback.code')}
                value={firstCode}
                name="name"
                onChange={handleChange}
            />
            <ButtonPrimary onClick={() => handleSearch()}>
                {t('feedback.search')}
            </ButtonPrimary>
        </Grid>
    );

    let inner = (
        <Grid>
            {currentMode === 0 && searchView}
            {currentMode > 0 && (
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}
                    container
                    spacing={4}
                    sx={{padding: '0px !important'}}
                    >
                    <Typography component="h1" variant='h4'>
                        {t('feedback.feedbackAndSignUp')}
                    </Typography>
                    <Grid spacing={2} sx={{marginBottom: '1vh'}}>
                        <Typography component="h2" variant='h5' sx={{color: '#0E4264', fontWeight: '600'}}>
                            {name + " "}
                        </Typography>
                        <Typography component="h2" variant='h5'>
                            {getDate()}
                        </Typography>
                     </Grid>
                </Grid>
            )}
            {currentMode === 1 && useAgeAndGender && !(useFeedbackRating || useFeedbackComment) &&
                <Typography component="h3">
                    {t('feedback.signUpDescription')}
                </Typography>
            }
            {currentMode === 1 && !useAgeAndGender && (useFeedbackRating || useFeedbackComment) &&
                <Typography component="h3" sx={{marginTop: '5%'}}>
                    {t('feedback.feedbackDescription')}
                </Typography>
            }
            {currentMode === 1 && useAgeAndGender && (useFeedbackRating || useFeedbackComment) &&
                <Typography component="h3">
                    {t('feedback.feedbackAndSignUpDescription')}
                </Typography>
            }
            <Box 
                style={{width: "100%"}}
                sx={{marginTop: '5%'}}
                display="flex"
                justifyContent="left"
                alignItems="center"
            >
                {currentMode === 1 && useAgeAndGender &&  chooseSignUp}
                {currentMode === 1 && (useFeedbackRating || useFeedbackComment) && chooseFeedback}
            </Box>
            <Grid>
                {currentMode === 3 && useAgeAndGender && <div>{t('feedback.genderSelect')}</div>}
                {currentMode === 2 && useFeedbackRating && <div>{t('feedback.feedbackRating')}</div>}
                <Grid sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '1vh',
                    marginBottom: '1vh'
                }}>
                    {currentMode === 3 && useAgeAndGender && ageComp}
                    {currentMode === 3 && useAgeAndGender && genderComp}
                </Grid>
            </Grid>
                {currentMode === 2 && useFeedbackRating && feedbackRating}
                {currentMode === 2 && useFeedbackComment && feedbackComment}
            <Box 
                style={{width: "100%"}}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                {currentMode > 1 && (useAgeAndGender || useFeedbackComment || useFeedbackRating) && backButton}
                {currentMode > 1 && (useAgeAndGender || useFeedbackComment || useFeedbackRating) && sendFeedbackButton}
            </Box>
            {sent && (
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Typography component="h2" className={'title green'}>
                        {t('feedback.feedbackSent')}
                    </Typography>
                </Grid>
            )}
            {error && (
                <Grid
                    size={{
                        xs: 12,
                        sm: 12
                    }}>
                    <Typography component="h2" className={'title red'}>
                        {t(error)}
                    </Typography>
                </Grid>
            )}
        </Grid>
    )
    
    return (
        <>
            {preview && (
                <Grid container spacing={4} size={{xs: 12, sm: 3 }} sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '5vh'}}>
                    <div className={'paperHeader'}>
                        <img className='login-logo' src={logoSrc} alt={t('common.youth_work')}/>
                    </div>
                    <Typography component="h4" variant='h4'>
                        {locationName ? (locationName + " " + t('feedback.feedbackAndSignUp').toLowerCase()) : null}
                    </Typography>
                    <img src={qr}/>
                </Grid>
            )}
            {!preview && (
                <Grid container className={"loginRoot"} sx={{padding: '0px !important'}}>
                    <AppHeader noLogo={true} />
                    <CssBaseline/>
                    <Grid className='site-wrapper loginBackgroundImage' sx={{width: '100%', paddingLeft: '20vh'}}>
                        <Grid className='login-box-wrapper' component={Paper} elevation={6} square size={{ xs: 12, sm: 9, md: 6 }} sx={{ height: currentMode === 2 || currentMode === 3 ? '100%' : '90vh' }}>
                            <Grid container spacing={4} className={'paper'}>
                                <div className={'paperHeader'}>
                                    <img className='login-logo' src={logoSrc} alt={t('common.youth_work')}/>
                                </div>
                                {currentMode === 5 && (
                                    <Typography component="h4" variant='h4'>
                                        {locationName ? (locationName + " " + t('feedback.feedbackAndSignUp').toLowerCase()) : null}
                                    </Typography>
                                )}
                                <Grid className={"mid feedbackmiddle"}>
                                    {currentMode !== 5 && inner}

                                {currentMode === 1 && (
                                    <ButtonSecondary onClick={() => currentMode === 1 ? handleBackToFeedbackList() : handleGoBack()}>
                                        <ArrowLeftIcon />
                                    </ButtonSecondary>
                                )}
                                {currentMode === 5 && feedbackList.map((row) => (
                                    <Grid size={{xs: 12, sm: 12}} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',borderBottom: '1px solid #0E4264', marginBottom: '2vh'}}>
                                        <Grid sx={{}}>
                                            <div className={'label label-size function-label'}>
                                                {row.name}
                                            </div>
                                            <div>
                                                {new Date(row.functionStartDatetime).toLocaleDateString() + " - " + new Date(row.functionEndDatetime).toLocaleDateString()}
                                            </div>
                                            <div>
                                                {new Date(row.functionStartDatetime).toLocaleTimeString('fi-FI', dateOptions) + " - " + new Date(row.functionEndDatetime).toLocaleTimeString('fi-FI', dateOptions)}
                                            </div>
                                        </Grid>
                                        <ButtonPrimary onClick={e => selectFeedback(row)}>
                                            <ArrowRightIcon />
                                        </ButtonPrimary>
                                    </Grid>
                                    ))}
                                {currentMode === 5 && feedbackList.length === 0 && (
                                    <Typography component="h5" variant='h5'>
                                        {t('feedback.noCurrentFeedback')}
                                    </Typography>
                                )}
                                </Grid>
                            </Grid>
                            <Grid container className={'footer-container'}>
                                <Grid size={{xs: 12, sm: 4, md: 3 }}>
                                    <a href={'https://nuorisotilastot.fi/wp-content/uploads/2025/01/2025_01_07_Tietosuojailmoitus_nuodo.pdf'} target='_blank' rel="noopener noreferrer" className={'link-data-privacy'}>
                                        {t('footer.privacy_statement')}
                                    </a>
                            </Grid>
                                <Grid size={{xs: 12, sm: 4, md: 3}}>
                                    <a href={'https://nuorisotilastot.fi/2350/uncategorized/nuodo-info/'} target='_blank' rel="noopener noreferrer" className={'link-accessibility'}>
                                        {t('footer.accessibility_statement')}
                                    </a>
                                </Grid>
                                <Grid size={{xs: 12, sm: 4, md: 3}}>
                                    <div className={'copyright'}>© {t('common.application_owner')} {new Date().getFullYear()}</div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </>
    );
}

FeedbackComponent.propTypes = {
    label: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
    return {
        props: ownProps,
        locationName: state.auth.locationName
    }
}
const mapDispatchToProps = dispatch => {
    return {
        searchFunction: (queryString, onSuccess, onFailure) => dispatch(searchFunction(queryString, onSuccess, onFailure)),
        sendFeedbackItem: (queryString, data, onSuccess, onFailure) => dispatch(sendFeedbackItem(queryString, data, onSuccess, onFailure))
    };
}

const Feedback = connect(mapStateToProps, mapDispatchToProps)(FeedbackComponent);

export {Feedback};